// src/components/home/QuickActionsCard.jsx
import React from "react";
import { History, Repeat2 } from "lucide-react";
import { Link } from "react-router-dom";

const QuickActionsCard = () => {
  return (
    <div className="card shadow-sm">
      <div className="card-body p-5">
        <p className="fw-bold mb-3">Quick Actions</p>
        <Link
          to="/workflow-instances"
          className="d-flex align-items-center gap-3 mb-2 quick-action-item text-decoration-none"
        >
          <Repeat2 size={20} className="" />
          <span className="fw-semibold">Workflow Instances</span>
        </Link>
        <Link
          to="/workflow-instances-history"
          className="d-flex align-items-center gap-3 mb-2 quick-action-item text-decoration-none"
        >
          <History size={20} className="" />
          <span className="fw-semibold">Workflow Instances History</span>
        </Link>
      </div>
    </div>
  );
};

export default QuickActionsCard;
